import { Fragment as WebView } from 'react';
// make sure when using this to implement redirect to a new tab in corresponding file
export default WebView;
